import { render } from "./Text.vue?vue&type=template&id=5aa0a860&scoped=true&bindings={\"size\":\"props\",\"weight\":\"props\",\"color\":\"props\",\"align\":\"props\",\"action\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=5aa0a860&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5aa0a860"

export default script